/* global axios */
import ApiClient from './ApiClient';

class ActivityAPI extends ApiClient {
  constructor() {
    super('activities', { accountScoped: true });
  }

  // Listar atividades com filtros
  get(params = {}) {
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        queryParams.append(key, value);
      }
    });

    const queryString = queryParams.toString();
    return axios.get(queryString ? `${this.url}?${queryString}` : this.url);
  }

  // Buscar atividade específica
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // Alias para compatibilidade
  getActivity(id) {
    return this.show(id);
  }

  // Criar atividade
  create(activityData) {
    return axios.post(this.url, { activity: activityData });
  }

  // Atualizar atividade
  update(id, activityData) {
    return axios.patch(`${this.url}/${id}`, { activity: activityData });
  }

  // Deletar atividade
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Marcar como concluída
  complete(id, outcome = null, outcomeNotes = null) {
    return axios.post(`${this.url}/${id}/complete`, {
      outcome,
      outcome_notes: outcomeNotes,
    });
  }

  // Cancelar
  cancel(id, notes = null) {
    return axios.post(`${this.url}/${id}/cancel`, {
      notes,
    });
  }

  // Reagendar
  reschedule(id, dueAt) {
    return axios.post(`${this.url}/${id}/reschedule`, {
      due_at: dueAt,
    });
  }

  // Dashboard views
  getToday() {
    return axios.get(`${this.url}/today`);
  }

  getOverdue() {
    return axios.get(`${this.url}/overdue`);
  }

  getUpcoming(days = 7) {
    return axios.get(`${this.url}/upcoming`, {
      params: { days },
    });
  }

  getSummary(userId = null, date = null) {
    return axios.get(`${this.url}/summary`, {
      params: {
        user_id: userId,
        date,
      },
    });
  }

  // Context-specific activities
  getForDeal(dealId) {
    return axios.get(`${this.url}/for_deal`, {
      params: { deal_id: dealId },
    });
  }

  getForContact(contactId) {
    return axios.get(`${this.url}/for_contact`, {
      params: { contact_id: contactId },
    });
  }

  getForConversation(conversationId) {
    return axios.get(`${this.url}/for_conversation`, {
      params: { conversation_id: conversationId },
    });
  }

  // Aliases para compatibilidade com código existente
  forDeal(dealId, page = 1) {
    return this.get({
      page,
      deal_id: dealId,
    });
  }

  forContact(contactId, page = 1) {
    return this.get({
      page,
      contact_id: contactId,
    });
  }

  forConversation(conversationId, page = 1) {
    return this.get({
      page,
      conversation_id: conversationId,
    });
  }

  // Bulk operations
  bulkComplete(activityIds, outcome = null, notes = null) {
    return axios.post(`${this.url}/bulk_complete`, {
      activity_ids: activityIds,
      outcome,
      notes,
    });
  }

  // Atividades pendentes (alias)
  getPendingTasks(page = 1) {
    return this.get({ page, status: 'scheduled' });
  }

  // Atividades atrasadas (alias)
  getOverdueTasks(page = 1) {
    return this.getOverdue();
  }
}

export default new ActivityAPI();
